import React, { useState, useEffect, Fragment } from "react";

const CompanyLocationTable = (
    emptypeData,
    handleDelete,
    handleEditLocation,
    onClickToggleFromTable
) => {
  const [thead] = useState(["Address","Phone","Pin", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = emptypeData.map((el) => {
      return {
        "Address": el.address,
        "Phone": el.phoneNo,
        "Pin": el.pin,
        Action: (
  <Fragment>
    <i
      className="fas fa-edit ml-4"
      style={{ marginRight: "10px", cursor: "pointer" }}
      onClick={() => {
        handleEditLocation(el);
        onClickToggleFromTable();
      }}
    ></i>
    <i
      className="fas fa-trash"
      style={{ cursor: "pointer" }}
      onClick={() => handleDelete(el.officeLocationId)}
    ></i>
  </Fragment>
),
      };
    });

     setTrow(trowArr);
  }, [
    emptypeData,
    handleDelete,
    handleEditLocation,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default CompanyLocationTable;